import Image from 'global/Image';
import Text from '@deprecated-ui/common/Text';
import color from '@deprecated-ui/_style/color';
import { useMemo, useState } from 'react';
import sanitizeHTML from 'sanitize-html';
import parse from 'html-react-parser';
import Autolinker from 'autolinker';
import { HostDetail, HostLogo, WidgetHostContainer } from './styled';

const MAX_DESCRIPTION_LENGTH = 286;
interface WidgetHostDetailProps {
  name: string;
  description: string;
  logoUrl: string;
}

function WidgetHostDetail({
  name,
  description,
  logoUrl,
}: WidgetHostDetailProps) {
  const [more, showMore] = useState(false);

  const showedDescription = useMemo(() => {
    if (description.length > MAX_DESCRIPTION_LENGTH && !more) {
      let croppedText = '';
      description
        .replace(/\s+/g, '  ')
        .split(' ')
        .every((word, index) => {
          const temp = index === 0 ? word : [croppedText, word].join(' ');
          if (temp.length > MAX_DESCRIPTION_LENGTH) {
            return false;
          }
          croppedText = temp;
          return true;
        });

      const htmlString = Autolinker.link(croppedText, {
        stripPrefix: false,
      });

      return parse(sanitizeHTML(`${htmlString}...`));
    }

    const htmlString = sanitizeHTML(
      Autolinker.link(description.replace(/(\n|\r\n)/g, '<br />'), {
        stripPrefix: false,
      }),
    );
    const parsedText = parse(htmlString);
    return parsedText;
  }, [more, description]);

  const showReadMore = !more && description.length > MAX_DESCRIPTION_LENGTH;

  return (
    <WidgetHostContainer id="livestream-widget-host-detail">
      <HostLogo>
        <Image
          src={logoUrl}
          alt={`${name} Logo`}
          id="livestream-widget-host-logo"
        />
      </HostLogo>
      <HostDetail>
        <Text
          size="13px"
          height="18px"
          weight="700"
          family="bold"
          color={color.highempahis}
          id="livestream-widget-host-name"
        >
          {name}
        </Text>
        <Text weight="400" size="11px" height="15px" color={color.highgray}>
          Host
        </Text>
        <Text
          // @ts-expect-error
          mt="12px"
          weight="400"
          size="13px"
          height="20px"
          color={color.highempahis}
          id="livestream-widget-host-description"
        >
          {showedDescription}
          {showReadMore && (
            <Text
              color={color.primary}
              family="bold"
              onClick={() => showMore(true)}
              style={{ cursor: 'pointer', display: 'inline-block' }}
              id="livestream-widget-host-description-readmore"
            >
              Read more
            </Text>
          )}
        </Text>
        {more && description.length > MAX_DESCRIPTION_LENGTH && (
          <Text
            color={color.primary}
            family="bold"
            onClick={() => showMore(false)}
            style={{ cursor: 'pointer' }}
            id="livestream-widget-host-description-showless"
          >
            Show Less
          </Text>
        )}
      </HostDetail>
    </WidgetHostContainer>
  );
}

export default WidgetHostDetail;
